import * as React from 'react';
import { observer } from 'mobx-react';
import autobind from "autobind-decorator";
import { Button, Tabs, Breadcrumb, Icon, Col, Row } from 'antd';

import { DropdownView } from 'src/core/ui/dropdown.view';
import { resolve } from 'inversify-react';
import { RulesReflectionService } from 'src/app/rules/rules/rules.reflection.service';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { DateView } from 'src/core/ui/date.view';


interface EventValueFieldProps {
	onChange: (name: any[]) => void;
	properties: EventProperty[];
	mode: ControlMode;
	label?: string;
	multiple?: boolean;
	value: string[];
}

@observer
export class EventValueField extends React.Component<EventValueFieldProps, any> {
	constructor(props) {
		super(props);

	}

	render() {
		
		return (<DropdownView
					label={this.props.label}
					model={this.props.value}
					multi
					disabled={this.props.mode == 'display'}
					onChanged={(e) => this.props.onChange(e)}
					options={this.props.properties}
					keyField='propertyName'
					textField='displayName'
						/>);
	}
}



// WEBPACK FOOTER //
// ./src/app/rules/rules/form/parts/conditions/event-value.field.tsx